<template>
  <div class="flex flex-col">
    <TableClients />
  </div>
</template>

<script>
import TableClients from '@/components/Table/Clients'

export default {
  components: {
    TableClients,
  },
  theme() {
    return {
      title: 'Clients',
      buttons: [
        {
          to: '/clients/add',
          label: '+ Ajouter client',
        },
      ],
    }
  },
}
</script>

<style></style>
